module.exports = __webpack_public_path__ + "media/3.3a9ccf10.mp3";